import { Navigate } from 'react-router-dom';

// Old bookmarked callbacks restart sign-in; managed session IDs are never exchanged.
export default function GoogleCallback() {
  return <Navigate to="/login" replace />;
}